import Swiper from 'swiper';

export default (element) => {
  const init = () => {
    const sliderDiv = element.querySelector('[data-collections-slider]');

    // eslint-disable-next-line
    const slider = new Swiper(sliderDiv, {
      slidesPerView: 1.8,
      spaceBetween: 6,
      navigation: {
        prevEl: '.swiper-button-prev',
        nextEl: '.swiper-button-next',
      },
      breakpoints: {
        768: {
          slidesPerView: 2.6402,
        },
        1024: {
          slidesPerView: 4,
        },
      },
    });
  };

  init();
};
